import React, { useState } from 'react';

function RequestDetail({ request, onClose, onSave }) {
  const [editedTarget, setEditedTarget] = useState(request.target || request.Spanish || '');
  const [saving, setSaving] = useState(false);

  const source = request.source || request.English || '';
  const originalTarget = request.target || request.Spanish || '';
  const isCompleted = request.status === 'completed';
  const hasTarget = !!originalTarget;

  const handleSave = async () => {
    if (!editedTarget.trim() || !source.trim()) {
      return;
    }

    setSaving(true);
    try {
      await onSave(request.req_id, source, editedTarget.trim());
    } catch (error) {
      // Error handled by parent
    } finally {
      setSaving(false);
    }
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'submitted':
      case 'pending':
        return 'status-submitted';
      case 'processing':
        return 'status-processing';
      case 'completed':
        return 'status-completed';
      case 'error':
        return 'status-error';
      default:
        return 'status-submitted';
    }
  };

  const getTypeClass = (type) => {
    switch (type?.toLowerCase()) {
      case 'exact':
        return 'type-exact';
      case 'fuzzy-adapted':
      case 'fuzzy':
        return 'type-fuzzy-adapted';
      case 'custom':
        return 'type-custom';
      default:
        return '';
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Translation Request Details</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="detail-row">
            <div className="detail-label">Request ID</div>
            <div className="detail-value">
              <code>{request.req_id}</code>
            </div>
          </div>

          <div className="form-row">
            <div className="detail-row">
              <div className="detail-label">Status</div>
              <div className="detail-value">
                <span className={`status-badge ${getStatusClass(request.status)}`}>
                  {request.status || 'pending'}
                </span>
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-label">Translation Type</div>
              <div className="detail-value">
                {request.translation_type ? (
                  <span className={`type-badge ${getTypeClass(request.translation_type)}`}>
                    {request.translation_type}
                  </span>
                ) : (
                  '-'
                )}
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-label">Category</div>
              <div className="detail-value">{request.category || 'general'}</div>
            </div>
          </div>

          <div className="form-row">
            <div className="detail-row">
              <div className="detail-label">Source Language</div>
              <div className="detail-value">{request.sourceLanguage || 'en-US'}</div>
            </div>

            <div className="detail-row">
              <div className="detail-label">Target Language</div>
              <div className="detail-value">{request.targetLanguage || 'es-US'}</div>
            </div>

            <div className="detail-row">
              <div className="detail-label">Received Date</div>
              <div className="detail-value">
                {request.received_date
                  ? new Date(request.received_date).toLocaleString()
                  : '-'}
              </div>
            </div>
          </div>

          <div className="detail-row">
            <div className="detail-label">Source Text (English)</div>
            <div className="detail-value" style={{ 
              padding: '0.75rem', 
              background: '#f5f7fa', 
              borderRadius: '4px',
              whiteSpace: 'pre-wrap'
            }}>
              {source || '-'}
            </div>
          </div>

          <div className="detail-row">
            <div className="detail-label">
              Target Text (Spanish)
              {hasTarget && isCompleted && (
                <span style={{ fontWeight: 'normal', marginLeft: '0.5rem', color: '#6c757d' }}>
                  - Edit below to save to Translation Memory
                </span>
              )}
            </div>
            {hasTarget ? (
              <textarea
                className="form-textarea"
                value={editedTarget}
                onChange={(e) => setEditedTarget(e.target.value)}
                style={{ minHeight: '100px' }}
              />
            ) : (
              <div className="detail-value" style={{ 
                padding: '0.75rem', 
                background: '#fff3cd', 
                borderRadius: '4px',
                color: '#856404'
              }}>
                Translation not yet available. Please refresh.
              </div>
            )}
          </div>

          {request.error_message && (
            <div className="detail-row">
              <div className="detail-label">Error Message</div>
              <div className="detail-value" style={{ 
                padding: '0.75rem', 
                background: '#f8d7da', 
                borderRadius: '4px',
                color: '#721c24'
              }}>
                {request.error_message}
              </div>
            </div>
          )}

          {request.fuzzy_similarity && (
            <div className="detail-row">
              <div className="detail-label">Fuzzy Match Similarity</div>
              <div className="detail-value">{request.fuzzy_similarity}%</div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          {hasTarget && isCompleted && (
            <button
              className="btn btn-success"
              onClick={handleSave}
              disabled={saving || !editedTarget.trim() || editedTarget === originalTarget}
            >
              {saving ? (
                <>
                  <span className="spinner"></span>
                  Saving...
                </>
              ) : (
                '✓ Save to Translation Memory'
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default RequestDetail;
